import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

function fetchCurrentUserAPI(email, password) {
  return new Promise((resolve, reject) => {

    fetch("/api/v1/user/me", {
      method: "get",
      redirect: "error",
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      }
    }).then((response) => {
        // should redirect
        if (response.status === 200) {
          response.json().then(data => { resolve({ user: data }) })
        } else {
          reject({ error: {type: "http", value: response.status} })
        }
    }).catch((error) => {
      if (error.message.startsWith("Not allowed to follow a redirection")) {
        reject({ error: { type: "loggedout", value: null } });
      } else {
        reject({ error: {type: "unknown", value: error } });
      }
    })

  })
}


const initialState = {
  user: null,
  error: null,
  status: 'idle',
};

// https://redux-toolkit.js.org/api/createAsyncThunk#examples
export const fetchCurrentUser = createAsyncThunk(
  'current_user/fetch',
  async (data, { rejectWithValue }) => {
    // The value we return becomes the `fulfilled` action payload
    try {
      return await fetchCurrentUserAPI();
    } catch(err) {
      console.log("ERROR: ", err)
      return rejectWithValue(err.error);
    }
  }
);

export const currentUserSlice = createSlice({
  name: 'current_user',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.status = 'resolved';
        state.user = action.payload.user;
        state.error = action.payload.error;
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        state.status = 'rejected';
        state.user = null;
        state.error = action.error;
      });
  },
});

// export const {} = counterSlice.actions;

export const selectCurrentUser = (state) => state.current_user

export default currentUserSlice.reducer;
